import { escapeRegExp } from '@/utils/string';
import DOMPurify from 'dompurify';

export const initHighlightTextDirective = (Vue) => {
  Vue.directive('highlight-text', {
    beforeMount: function (el, binding) {
      runDirective(el, binding);
    },
    beforeUpdate: function (el, binding) {
      runDirective(el, binding);
    },
  });
};

export const runDirective = (el, binding) => {
  if (binding.value.subElementTargetSelector) {
    el = el.querySelector(binding.value.subElementTargetSelector);
  }

  // strip out any existing <mark> tags. Creating temp div to avoid mutating the original element that may lead to XSS vulnerabilities.

  let originalContent = el.innerHTML;
  originalContent = originalContent.replace(/<mark[^>]*>/g, '');
  originalContent = originalContent.replace(/<\/mark>/g, '');
  const highlightedContent = highlightSearchText(
    originalContent,
    binding.value.textToHighlight,
  );
  el.innerHTML = DOMPurify.sanitize(highlightedContent);
};

export const highlightSearchText = (targetText, textToHighlight) => {
  if (!textToHighlight || !targetText) return targetText;

  const escapedSearchText = escapeRegExp(textToHighlight);
  const regex = new RegExp(`(${escapedSearchText})`, 'gi');
  return targetText.replace(regex, '<mark class="highlight-text">$1</mark>');
};
